import React from 'react';

function rarityLabel(value) {
  switch (value) {
    case 'legendary':
      return 'Legendär';
    case 'epic':
      return 'Episch';
    case 'rare':
      return 'Selten';
    default:
      return 'Gewöhnlich';
  }
}

function AvatarTile({ avatar, isActive, onSelect, saving }) {
  const locked = !avatar?.is_unlocked;

  return (
    <button
      type="button"
      className={`avatar-picker__tile${isActive ? ' is-active' : ''}${locked ? ' is-locked' : ''}`}
      onClick={() => !locked && !saving && onSelect?.(avatar.id)}
      disabled={saving || locked}
    >
      <div className="avatar-picker__image-wrap">
        <img src={avatar.image_url || avatar.thumb_url} alt={avatar.title} className="avatar-picker__image" />
      </div>
      <div className="avatar-picker__tile-title">{avatar.title}</div>
      <div className="avatar-picker__tile-meta">
        <span className={`avatar-picker__rarity avatar-picker__rarity--${avatar.rarity || 'common'}`}>
          {rarityLabel(avatar.rarity)}
        </span>
        {isActive ? <span className="avatar-picker__current">Aktiv</span> : null}
      </div>
      {locked ? <div className="avatar-picker__hint">{avatar.locked_hint || 'Noch nicht freigeschaltet'}</div> : null}
    </button>
  );
}

export default function AvatarPickerModal({
  isOpen,
  onClose,
  avatars = [],
  selectedAvatarId,
  onSelect,
  saving = false,
}) {
  if (!isOpen) {
    return null;
  }

  const unlocked = avatars.filter((avatar) => avatar?.is_unlocked);
  const locked = avatars.filter((avatar) => !avatar?.is_unlocked);

  return (
    <div className="avatar-picker" role="dialog" aria-modal="true" aria-labelledby="avatar-picker-title">
      <div className="avatar-picker__backdrop" onClick={onClose} />
      <div className="avatar-picker__sheet">
        <div className="avatar-picker__header">
          <div>
            <h3 id="avatar-picker-title">Avatar ändern</h3>
            <p>Wähle einen freigeschalteten Pfandpirat-Avatar aus.</p>
          </div>
          <button type="button" className="avatar-picker__close" onClick={onClose}>
            Schließen
          </button>
        </div>

        <div className="avatar-picker__section">
          <div className="avatar-picker__section-title">Freigeschaltet</div>
          <div className="avatar-picker__grid">
            {unlocked.map((avatar) => (
              <AvatarTile
                key={avatar.id}
                avatar={avatar}
                isActive={Number(avatar.id) === Number(selectedAvatarId)}
                onSelect={onSelect}
                saving={saving}
              />
            ))}
          </div>
        </div>

        {locked.length ? (
          <div className="avatar-picker__section">
            <div className="avatar-picker__section-title">Noch gesperrt</div>
            <div className="avatar-picker__grid">
              {locked.map((avatar) => (
                <AvatarTile
                  key={avatar.id}
                  avatar={avatar}
                  isActive={false}
                  onSelect={onSelect}
                  saving={saving}
                />
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
